import React from 'react'


const ClipIcon = (props) =>
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 16 16">
        <path
            d="M5 4v8c0 1.5 1.5 3 3 3s3-1.5 3-3V4h1v8c0 2-2 4-4 4s-4-2-4-4V3c0-1.5 1.5-3 3-3s3 1.5 3 3v8c0 1-1 2-2 2s-2-1-2-2V4h1v7c0 .5.5 1 1 1s1-.5 1-1V3c0-1-1-2-2-2S5 2 5 3zm0 0" fillRule="evenodd"/>
    </svg>


export default ClipIcon



// WEBPACK FOOTER //
// ./src/components/_common/_icons/ClipIcon.js